import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Check, Copy } from 'lucide-react';
import { Botao } from './base';
import { Modal } from './sobreposicao';
import { dataHora } from '../nucleo/formato';

/** val1 (28/10): o que o servidor devolve ao criar o acesso por nome de usuário (ou ao gerar nova senha provisória). */
export interface DadosAcessoCriado {
  usuario: string;
  senha_provisoria: string;
  expira_em: string;
}

/**
 * Mostra UMA vez o nome de usuário e a senha provisória (quem criou entrega à pessoa). Fechado, não volta: a senha não fica
 * em lugar nenhum (no servidor, só o hash). Vale até `expira_em` e é trocada no primeiro acesso.
 */
export function AcessoCriadoModal({ dados, aoFechar }: { dados: DadosAcessoCriado | null; aoFechar: () => void }) {
  const { t } = useTranslation();
  const [copiado, setCopiado] = useState(false);
  if (!dados) return null;
  const texto = `${t('formasAcesso.acessoCriado.usuario')}: ${dados.usuario}\n${t('formasAcesso.acessoCriado.senha')}: ${dados.senha_provisoria}`;
  const fechar = () => {
    setCopiado(false);
    aoFechar();
  };
  return (
    <Modal
      aberto
      aoFechar={fechar}
      titulo={t('formasAcesso.acessoCriado.titulo')}
      rodape={
        <Botao variante="primario" onClick={fechar}>
          {t('formasAcesso.acessoCriado.fechar')}
        </Botao>
      }
    >
      <div className="flex flex-col gap-4" data-acesso-criado>
        <p className="text-sm text-tinta-2">{t('formasAcesso.acessoCriado.texto', { quando: dataHora(dados.expira_em) })}</p>
        <dl className="grid gap-3 rounded-lg border border-borda bg-sup-2 p-3">
          <div className="min-w-0">
            <dt className="text-xs text-tinta-3">{t('formasAcesso.acessoCriado.usuario')}</dt>
            <dd className="numero text-sm break-all text-tinta-1">{dados.usuario}</dd>
          </div>
          <div className="min-w-0">
            <dt className="text-xs text-tinta-3">{t('formasAcesso.acessoCriado.senha')}</dt>
            <dd className="numero text-sm break-all text-tinta-1">{dados.senha_provisoria}</dd>
          </div>
        </dl>
        <div className="flex justify-end">
          <Botao
            icone={copiado ? <Check className="size-4" aria-hidden /> : <Copy className="size-4" aria-hidden />}
            onClick={async () => {
              try {
                await navigator.clipboard.writeText(texto);
                setCopiado(true);
              } catch {
                setCopiado(false);
              }
            }}
          >
            {copiado ? t('formasAcesso.acessoCriado.copiado') : t('formasAcesso.acessoCriado.copiar')}
          </Botao>
        </div>
      </div>
    </Modal>
  );
}
